import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M4 17l.1162.0068C4.612 17.0648 5 17.4893 5 18v3c0 .55-.45 1-1 1l-.1162-.0068C3.388 21.9352 3 21.5107 3 21v-3c0-.55.45-1 1-1zm4 0l.1162.0068C8.612 17.0648 9 17.4893 9 18v3c0 .55-.45 1-1 1l-.1162-.0068C7.388 21.9352 7 21.5107 7 21v-3c0-.55.45-1 1-1zm4 0l.1162.0068c.4958.058.8838.4825.8838.9932v3c0 .55-.45 1-1 1l-.1162-.0068C11.388 21.9352 11 21.5107 11 21v-3c0-.55.45-1 1-1zm8 0c.55 0 1 .45 1 1v3c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1zM12 3c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6 2.69-6 6-6zm0 2l-.1246.0084c-.3264.0443-.601.2616-.7254.5816l-2.12 5.65c-.14.37.14.76.53.76l.0884-.0069c.202-.0318.3716-.1718.4416-.3731l.5-1.41h2.83l.49 1.41c.08.23.29.38.53.38l.0899-.0067c.3492-.0532.5693-.4118.4401-.7533l-2.12-5.65C12.71 5.23 12.38 5 12 5zm.03 1.3l1.02 2.89h-2.1l1.02-2.89z"
  }],
  circles: []
};
var AutofpsSelectIcon = function AutofpsSelectIcon(props) {
  return renderIcon(props, iconType);
};
export { AutofpsSelectIcon };